module.exports = __webpack_public_path__ + "static/viernes-06-11-83637eac5729386a4e35fca8e3006815.jpg";